
import { updateFilterUrl, parseFilterUrl } from './functions/url';
import { filterItems } from './functions/filters';

import React, { useState, useEffect } from 'react';

import Grid from './components/Grid';
import TopFilters from './components/TopFilters';
import SideFilters from './components/SideFilters';
import SideFiltersNav from './components/SideFiltersNav';
import SelectedFilters from './components/SelectedFilters.js';
import Pagination from './components/Pagination';

import SelectedTopFilter from './components/SelectedTopFilter.js';
import TotalResults from './components/TotalResults.js';
import TotalResultsBottom from './components/TotalResultsBottom.js';

import HiddenSearch from './components/HiddenSearch.js';

import { FilterContextProvider } from "./context/context";



function FilterUI(props) {

  const {
    filter_form,
    top_filters,
    items,
    active_filters,
    start_date,
    end_date,
    current_page
  } = props;

  const [selectedFilters, setSelectedFilters] = useState(filter_form);
  const [activeFilters, setActiveFilters] = useState(active_filters);
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);
  const [filteredItems, setFilteredItems] = useState(items);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(current_page);

  const states = {
    selectedFilters, setSelectedFilters,
    activeFilters, setActiveFilters,
    startDate, setStartDate,
    endDate, setEndDate,
    filteredItems, setFilteredItems,
    searchQuery, setSearchQuery,
    currentPage, setCurrentPage
  };

  useEffect(() => {
    updateFilterUrl(selectedFilters, currentPage);
    let filter_items = filterItems(items, selectedFilters, searchQuery);
    setFilteredItems(filter_items);

    let totalPageCount = Math.ceil(filter_items.length / 12);
    if (currentPage > totalPageCount) {
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }

  }, [selectedFilters, searchQuery, currentPage]);


  const toggleFilterPanel = (panel) => {
    let active_filters = activeFilters;
    // bodyScrollLock.clearAllBodyScrollLocks();

    if (active_filters.active_panel === panel && active_filters.mobile_open) {
      active_filters.mobile_open = false;
      document.querySelector('body').classList.remove('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();
    } else {
      active_filters.mobile_open = true;
      document.querySelector('body').classList.add('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();
      // bodyScrollLock.disableBodyScroll('.side-filter-section-inner')
    }

    active_filters.active_panel = panel;

    setActiveFilters(
      { ...activeFilters },
      active_filters
    )
  }


  const closeFilterPanel = () => {
    let active_filters = {
      mobile_open: false,
      active_panel: 'side_filter',
      top_filter_open: false,
      side_filter_open: false,
      active_side_filter: '',
      active_date_panel: ''
    };

    document.querySelector('body').classList.remove('filter-open');
    // bodyScrollLock.clearAllBodyScrollLocks();

    setActiveFilters(
      active_filters
    )
  }

  const toggleMobileFilters = () => {
    let active_filters = activeFilters;
    active_filters.mobile_open = !activeFilters.mobile_open;
    active_filters.active_side_filter = "";
    if (active_filters.mobile_open) {
      document.querySelector('body').classList.add('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();
      //
      // bodyScrollLock.disableBodyScroll('.side-filter-section-inner')

    } else {
      document.querySelector('body').classList.remove('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();
    }

    setActiveFilters(
      { ...activeFilters },
      active_filters
    )
  }


  return (
    <>


      <FilterContextProvider value={states}>
        <div
          className={`filters-bg ${activeFilters.mobile_open || activeFilters.active_side_filter.length > 0 ? "active" : ""}`}
          onClick={() => closeFilterPanel('')}
        >
        </div>
        <div className={`mobile-triggers ${activeFilters.mobile_open ? "active" : ""}`}>
          <div className="container">
            <button className={`filter-trigger trigger-side ${activeFilters.mobile_open && activeFilters.active_panel === "side_filter" ? "active" : ""}`} onClick={() => toggleFilterPanel("side_filter")}>
              <span>
                Filter by
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
                  <g clip-path="url(#clip0_2546_4667)">
                    <path d="M6.07094 0C4.46794 0 3.13779 1.09141 2.72851 2.59209H0.920873C0.409277 2.59209 0 2.96726 0 3.47885C0 3.99045 0.409277 4.36562 0.920873 4.36562H2.72851C3.13779 5.8322 4.46794 6.95771 6.07094 6.95771C7.67394 6.95771 9.00409 5.8663 9.41337 4.39973H24.3861C24.8977 4.36562 25.2729 3.95634 25.2729 3.44475C25.2729 2.93315 24.8636 2.55798 24.3861 2.55798H9.41337C9.0382 1.12551 7.67394 0 6.07094 0ZM6.07094 1.80764C7.02592 1.80764 7.74216 2.55798 7.74216 3.47885C7.74216 4.39973 6.99181 5.15007 6.07094 5.15007C5.15007 5.15007 4.39973 4.39973 4.39973 3.47885C4.39973 2.55798 5.15007 1.80764 6.07094 1.80764ZM15.6889 8.73124C14.0518 8.73124 12.6876 9.85675 12.2783 11.3574H0.920873C0.409277 11.3574 0 11.7326 0 12.2442C0 12.7558 0.409277 13.131 0.886767 13.1651H12.2783C12.6876 14.6658 14.0518 15.7913 15.6889 15.7913C17.3261 15.7913 18.6903 14.6658 19.0996 13.1651H24.352C24.8636 13.1651 25.2387 12.7558 25.2387 12.2442C25.2387 11.7326 24.8295 11.3574 24.352 11.3574H19.0996C18.6903 9.85675 17.3261 8.73124 15.6889 8.73124ZM15.6889 10.5389C16.6439 10.5389 17.4284 11.2892 17.4284 12.2442C17.4284 13.1992 16.678 13.9836 15.6889 13.9836C14.6999 13.9836 13.9495 13.2333 13.9495 12.2442C13.9495 11.2551 14.6999 10.5389 15.6889 10.5389ZM8.69713 17.9059C7.06003 17.9059 5.69577 19.0314 5.28649 20.5321H0.920873C0.409277 20.5321 0 20.9413 0 21.4529C0 21.9645 0.409277 22.3397 0.920873 22.3397H5.28649C5.69577 23.8404 7.06003 24.9659 8.69713 24.9659C10.3342 24.9659 11.6985 23.8404 12.1078 22.3397H24.3861C24.8977 22.3397 25.2729 21.9304 25.2729 21.4529C25.2729 20.9413 24.8636 20.5321 24.3861 20.5321H12.1078C11.6985 19.0314 10.3342 17.9059 8.69713 17.9059ZM8.69713 19.7135C9.65211 19.7135 10.4366 20.4638 10.4366 21.4529C10.4366 22.442 9.68622 23.1924 8.69713 23.1924C7.70805 23.1924 6.95771 22.442 6.95771 21.4529C6.95771 20.4638 7.70805 19.7135 8.69713 19.7135Z" fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2546_4667">
                      <rect width="25.2729" height="25" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </button>
          </div>



        </div>
        <div className={`filters ${activeFilters.mobile_open ? "active" : ""}`}>



          <div className={`panel panel-side  ${activeFilters.active_panel === "side_filter" ? "active" : ""}`}>
            <SideFiltersNav
              form={filter_form}
            />
            <SideFilters
              form={filter_form}
            />
          </div>

        </div>

        <div className="filters-right">



          <TotalResults />
          <Grid />
          <HiddenSearch />

          <TotalResultsBottom />


          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={filteredItems.length}
            pageSize={12}
            onPageChange={page => setCurrentPage(page)}
          />
        </div>




      </FilterContextProvider>
    </>
  );
}

export default FilterUI;
